import { ApiError, Offer } from "@blacknut/javascript-sdk/dist";
import { Reducer } from "redux";
import { LGAction, LGActionTypes } from "../actions/LG/LG";

export interface State {
  offer?: Offer;
  loading: boolean;
  error?: ApiError;
}

const initialState: State = {
  offer: undefined,
  loading: false,
};

export const reducer: Reducer<State> = (state = initialState, action: LGAction) => {
  switch (action.type) {
    case LGActionTypes.OFFER_FETCH_REQUEST:
      return { loading: true };
    case LGActionTypes.OFFER_FETCH_SUCCESS:
      return { offer: action.offer, loading: false };
    case LGActionTypes.OFFER_FETCH_ERROR:
      return { loading: false, error: action.error };
    default:
      return state;
  }
};
